// client because parent is client

import React from 'react'

import getLicensePlateColor from '../../functions/extensions/lpColors'
import { states } from '../../GlobalVars'

const MiniLicensePlate = ({

    ticket,
    directState,
    directPlate

}) => {

    let direct = (directState !== "")

    // LP colors
    const findKeyByValue = (obj, value) => {
        return Object.keys(obj).find(key => obj[key] === value)

    };

    const { licensePlateColor, fontColor } = getLicensePlateColor(direct ? directState : ticket.carState);

    return (
        <div
            className={`flex h-[25px] border border-black rounded-[3px] items-center justify-center shadow-sm shadow-gray-500`}
            style={{ width: 65, backgroundColor: licensePlateColor }}
        >
            <p 
                className={`font-lpFont text-black text-[14px] relative top-[1px]`}
                style={{ color: fontColor }}
            >
                {direct ? directPlate?.toUpperCase() : ticket.licensePlate?.toUpperCase()}
            </p>
        </div>
    )
}

export default MiniLicensePlate